import * as api from '@sloyd/api';
import { actions } from '@sloyd/store-base';
import { toast } from '@sloyd/ui';
import { analyzeAction } from 'initial-state';
import { patchJson } from 'shared-base';
import { store } from '../utils/globals';
import { local } from '../utils/storage';

export const midConnected = (store: any) => (next: any) => async (action: Action) => {
  const info = analyzeAction(action);

  const handler = handlers[action.type];

  if (handler) {
    handler(store.getState(), action);
  }

  // action not connected
  if (!info) {
    return next(action);
  }

  return next(action);
};

const getApi = (action: any, projectId?: string) => {
  const { id } = action;

  if (id === 'play' || projectId === 'play' || action.payload?.id === 'play') return local;

  return api;
};

export const handlers: any = {
  ADD_PROJECT_ITEM: async (state: any, action: any) => {
    const { payload } = action;

    const api = getApi(action);

    try {
      const res = await api.projects.create(payload);

      if (!res.isSuccess) {
        toast.error('Failed to create project');
        store.dispatch(actions.projects.delete(payload.id));
        return;
      }
    } catch (err) {}
  },
  PATCH_PROJECT_ITEM: async (state: any, action: any) => {
    const { id, payload } = action;
    if ('models' in payload) return;
    const api = getApi(action);
    await api.projects.patch(id, payload);
  },
  CLEAR_PROJECT: async (state: any, action: any) => {
    const { id } = action;
    const api = getApi(action);
    await api.projects.clear(id);
    store.dispatch(actions.projects.patch(id, { models: {} }));
  },
  PATCH_MODEL_ITEM: async (state: any, action: any) => {
    const { id, payload } = action;
    const projectId = state.currentIds.projectId;
    store.dispatch({ type: 'REFRESH' });
    const api = getApi(action, projectId);
    await api.projects.patchModel(projectId, id, payload);
  },
  DELETE_MODEL_ITEM: async (state: any, action: any) => {
    const { id } = action;
    const projectId = state.currentIds.projectId;
    store.dispatch({ type: 'REFRESH' });
    const api = getApi(action, projectId);
    await api.projects.removeModel(projectId, id);
  },
  DELETE_PROJECT_ITEM: async (state: any, action: any) => {
    const { id } = action;
    await api.projects.remove(id);
  },
  SET_MODELS: async (state: any, action: any) => {
    const { payload } = action;
    const projectId = state.currentIds.projectId;
    const api = getApi(action, projectId);
    await api.projects.setModels(projectId, payload);
  },
  ADD_MODEL_ITEM: async (state: any, action: any) => {
    const { payload } = action;
    const projectId = state.currentIds.projectId;
    store.dispatch({ type: 'REFRESH' });
    const api = getApi(action, projectId);
    await api.projects.addModel(projectId, payload);
  },
  PATCH_SETTINGS: async (state: any, action: any) => {
    const { payload } = action;
    // await api.user.patchSettings(payload);
    patchJson('SETTINGS', payload);
  },
  PATCH_VALUESMODEL: async (state: any, action: any) => {
    const { payload } = action;

    const projectId = state.currentIds.projectId;
    const modelId = state.currentIds.modelId;

    store.dispatch({ type: 'REFRESH' });
    const api = getApi(action, projectId);
    await api.projects.patchModelValues(projectId, modelId, payload);
  },
};
